import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'DataTable' })({
    container: {
        padding: '24px',
        border: '1px solid #ECECEC',
        borderRadius: 16,
        boxSizing: 'border-box'
    },
    spinner: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 0'
    },
    pagination__root: {
        borderBottom: 'none',
        borderTop: '1px solid rgba(224, 224, 224, 1)'
    },
    pagination__toolbar: {
        paddingTop: 16,
        paddingLeft: 0,
        paddingRight: 0,
        overflow: 'hidden',
        minWidth: 'min-content'
    },
    sort: {
        flexDirection: 'row-reverse',
        color: '#5F5F5F !important',
        fontSize: 13,
        fontWeight: 700,
        lineHeight: 0,
        whiteSpace: 'nowrap',
        letterSpacing: '-0.26px'
    },
    sortIcon: {
        color: '#8E8E8E !important'
    },
    headerCell: {
        padding: '0 12px 24px 12px'
    },
    bodyCell: {
        color: '#232323',
        fontsize: 13,
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.26px',
        padding: '10px 12px'
    },
    footerCell: {
        paddingTop: 24
    }
});
